const translations = {
  tr: {
    // Navigation
    home: 'Ana Sayfa',
    about: 'Hakkımızda',
    team: 'Ekibimiz',
    publications: 'Yayınlarımız',
    contact: 'İletişim',

    // Home
    firmName: 'TAMA & ORAL',
    firmSubtitle: 'Avukatlık ve Arabuluculuk Bürosu',
    motto: 'Sorun değil, çözüm üretiyoruz.',
    lawyerQuote: 'Avukat, adli organların yanında yer alan, hukuk düzeninin ve insan hakları savunucusu olan bağımsız ve tarafsız danışman olmalıdır.',

    serviceAreas: 'Hizmet Alanlarımız',
    comprehensiveSolutions: 'Kapsamlı Hukuki Çözümler',
    familyLaw: 'Aile Hukuku',
    familyLawDesc: 'Boşanma, velayet, miras ve aile danışmanlığı',
    laborLaw: 'İş Hukuku',
    laborLawDesc: 'İş ilişkileri ve sosyal güvenlik',
    laborExpert: 'İş Hukuku Bilirkişisi',
    laborExpertDesc: 'İş davalarında alacak hesabı ve bilirkişi raporu',
    commercialLaw: 'Ticari Hukuk',
    commercialLawDesc: 'Ticari işlemler ve şirket kuruluşu',
    realEstateLaw: 'Gayrimenkul Hukuku',
    realEstateLawDesc: 'Mülk alım-satımı ve gayrimenkul anlaşmazlıkları',
    bankruptcyLaw: 'İflas ve İcra',
    bankruptcyLawDesc: 'Borç takibi ve iflas işlemleri',
    criminalLaw: 'Ceza Hukuku',
    criminalLawDesc: 'Ceza davası müdahaleleri',
    consumerLaw: 'Tüketici Hukuku',
    consumerLawDesc: 'Tüketici haklarının korunması',
    contractLaw: 'Sözleşme Hukuku',
    contractLawDesc: 'Sözleşme hazırlama ve müzakere',
    inheritanceLaw: 'Miras Hukuku',
    inheritanceLawDesc: 'Miras paylaşımı ve vesayet',
    rentalLaw: 'Kira Hukuku',
    rentalLawDesc: 'Kiracı ve ev sahibi ilişkileri',
    taxLaw: 'Vergi Hukuku',
    taxLawDesc: 'Vergi danışmanlığı ve uyuşmazlıklar',
    itLaw: 'BT Hukuku',
    itLawDesc: 'Teknoloji ve internet hukuku',

    needConsultation: 'Hukuki Danışmanlık İhtiyacınız mı Var?',
    teamReady: 'Profesyonel ekibimiz sizin için her zaman hazırdır.',
    contactUs: 'Bize Ulaşın',

    // About
    aboutUs: 'Hakkımızda',
    whoWeAre: 'Biz Kimiz?',
    whoWeAreText: 'TAMA & ORAL Hukuk Bürosu, müşteri odaklı ve yüksek kaliteli hukuki danışmanlık hizmetleri sunmak için kurulmuştur. Ekibimiz, her bir davada bağımsız ve tarafsız bir bakış açısı getirerek, müvekkillerin haklarını korumak ve çözümler üretmek için çalışır.',
    ourMission: 'Misyonumuz',
    ourMissionText: 'Profesyonel hukuki danışmanlık alanında, müşteri memnuniyetini ve mükeemmelse hukuk uygulamasını ön planda tutarak, her bir dava ve danışmanlık görevinde en yüksek standartları sağlamaktır.',
    ourVision: 'Vizyonumuz',
    ourVisionText: 'Türkiye\'de güvenilir, etik ve profesyonel hukuki hizmetler sağlayan, müvekkilleri tarafından tercih edilen bir hukuk bürosu olmaktır.',
    ourPhilosophy: 'Felsefemiz',
    ourPhilosophyText: '"Sorun değil, çözüm üretiyoruz." - Bu ilke, tüm çalışmalarımızın temelini oluşturur. Her müvekkil için uzun vadeli ilişki ve tatmin edici sonuçlar amaçlanır.',

    // Team
    ourTeam: 'Ekibimiz',
    professionalMeeting: 'Profesyonel ve deneyimli hukukçuların buluştuğu yer',
    founderLawyer: 'Kurucu Avukat',
    founderCat: 'Kurucu Kedi',
    omerOral: 'Av. Ömer Oral',
    omerBio: 'Vergi hukuku ve ticari hukuk alanında uzman. 15+ yıl tecrübesi ile müvekkillerin güveni kazanmıştır.',
    rumeysa: 'Av. Rumeysa Tama Oral',
    rumeyBio: 'Aile hukuku ve miras hukuku konusunda uzman. Duyarlı ve bütünsel yaklaşımı müvekkillerce takdir görmüştür.',
    suzi: 'Avukat Suzi',
    suziBio: 'Büronun ruh ve misyonunun temsili. Danışmanlık için her zaman dinlemeye hazır ve sakin bir enerjisi vardır.',
    ourValues: 'Değerlerimiz',
    independence: 'Bağımsızlık',
    independenceDesc: 'Müvekkillerimizin çıkarlarının savunusu için tamamen bağımsız hareket ederiz.',
    ethics: 'Etik',
    ethicsDesc: 'Tüm işlemlerimizde yüksek etik standartlarını korumuştur.',
    professionalism: 'Profesyonellik',
    professionalismDesc: 'Uzman bilgisi ve tecrübesi ile en iyi sonuçları sunuyoruz.',
    reliability: 'Güvenilirlik',
    reliabilityDesc: 'Müvekkillerin güveni, işimizin temelini oluşturur.',
    specializations: 'Uzmanlık Alanları',
    moralSupport: 'Moral Desteği',
    stressManagement: 'Stres Yönetimi',
    officeculture: 'Ofis Kültürü',

    // Publications
    ourPublications: 'Yayınlarımız',
    currentLegalInfo: 'Hukuki konularda güncel bilgiler ve analiz',
    article1: 'Araç Hasarı Tazminat Talebinde Dikkat Edilmesi Gerekenler',
    article1Date: '15 Mart 2024',
    article1Excerpt: 'Araç hasarı tazminat davasında hangilerini belgelemeniz gerekir? Tazminat talebinizi güçlü tutmak için neler yapmalısınız?',
    article2: 'Tüketici Sözleşmelerinde Gizli Şartlara Karşı Haklarınız',
    article2Date: '8 Mart 2024',
    article2Excerpt: 'Tüketicilere karşı uygulamada yaygın olan haksız şartlardan nasıl korunabilirsiniz? Yasal hakları nelerdir?',
    article3: 'Kira Sözleşmesinde Yapılan Değişikliklere Bir Bakış',
    article3Date: '1 Mart 2024',
    article3Excerpt: 'Yeni kira hukuku düzenlemeleri kiracı ve ev sahiplerini nasıl etkiledi? Bilmeniz gereken önemli noktalar neler?',
    article4: 'Aile Hukuku Davalarında Delil Toplanması',
    article4Date: '22 Şubat 2024',
    article4Excerpt: 'Aile hukuku davalarında hukuki sonuca etki edecek delil türleri ve bunların toplanmasında dikkat edilecek hususlar.',
    article5: 'Ticari Sözleşmelerde Risklerin Yönetimi',
    article5Date: '15 Şubat 2024',
    article5Excerpt: 'İşletmenizin korunması için sözleşmelerde bulunması gereken hükümler ve risk yönetimi stratejileri.',
    article6: 'Miras Bırakılanın Geçerli Bir Vasiyetname Hazırlanması',
    article6Date: '8 Şubat 2024',
    article6Excerpt: 'Vasiyetname yazıldıktan sonra ortaya çıkabilecek anlaşmazlıkları önlemek için neler yapılmalıdır?',
    readMore: 'Devamını Oku',
    subscribe: 'Bültene Abone Olun',
    newPublications: 'Yeni yayınlarımızı e-mail ile alın',
    subscribeBtnText: 'Abone Ol',
    emailPlaceholder: 'E-mail adresiniz',

    // Contact
    getInTouch: 'İletişim',
    reachOut: 'Bize ulaşın, sorularınıza yanıt verelim',
    address: 'Adres',
    addressText: 'Mansuroğlu Mah. 286/1 Sok. No:16 Ata Plaza K:7 D:28\nBayraklı İzmir',
    phone: 'Telefon',
    phoneText: '+90 (212) XXX-XXXX',
    mobile: 'Mobil',
    mobilePhone: '0537 937 10 64',
    landline: 'Telefon',
    landlinePhone: '0232 486 63 01',
    email: 'E-mail',
    workingHours: 'Çalışma Saatleri',
    workingHoursText: 'Pazartesi - Cuma: 09:00 - 18:00\nCumartesi - Pazar: Kapalı',
    kvkkText: 'Kişisel verilerimin KVKK kapsamında bu mesaja yanıt verilmesi amacıyla işlenmesine onay veriyorum.',
    sendMessage: 'Bize Mesaj Gönderin',
    fullName: 'Ad Soyad',
    fullNameReq: 'Ad Soyad *',
    emailReq: 'E-mail *',
    phone2: 'Telefon',
    subject: 'Konu *',
    message: 'Mesajınız *',
    send: 'Gönder',
    messageReceived: 'Mesajınız alındı. En kısa sürede sizinle iletişime geçeceğiz.',
    ourLocation: 'Konumumuz',
    mapPlaceholder: 'Harita burada gösterilecektir',
    required: '*',

    // Footer
    legalServices: 'Profesyonel Hukuki Danışmanlık Hizmetleri',
    socialMedia: 'Sosyal Medya',
    legal: 'Yasal',
    privacy: 'Gizlilik Politikası',
    terms: 'Kullanım Şartları',
    copyright: '© 2024 TAMA & ORAL Hukuk Bürosu. Tüm hakları saklıdır.',
  },

  en: {
    // Navigation
    home: 'Home',
    about: 'About',
    team: 'Team',
    publications: 'Publications',
    contact: 'Contact',

    // Home
    firmName: 'TAMA & ORAL',
    firmSubtitle: 'Law Office',
    motto: 'Creating Solutions, Not Problems',
    lawyerQuote: 'A lawyer should be an independent and impartial adviser to the courts, supporting the legal system and human rights.',

    serviceAreas: 'Service Areas',
    comprehensiveSolutions: 'Comprehensive Legal Solutions',
    familyLaw: 'Family Law',
    familyLawDesc: 'Divorce, custody, inheritance and family counseling',
    laborLaw: 'Labor Law',
    laborLawDesc: 'Employment relations and social security',
    laborExpert: 'Labor Law Expert Witness',
    laborExpertDesc: 'Receivables calculation and expert reports in labor cases',
    commercialLaw: 'Commercial Law',
    commercialLawDesc: 'Commercial transactions and company formation',
    realEstateLaw: 'Real Estate Law',
    realEstateLawDesc: 'Property buying-selling and real estate disputes',
    bankruptcyLaw: 'Bankruptcy & Enforcement',
    bankruptcyLawDesc: 'Debt collection and bankruptcy proceedings',
    criminalLaw: 'Criminal Law',
    criminalLawDesc: 'Criminal case interventions',
    consumerLaw: 'Consumer Law',
    consumerLawDesc: 'Consumer rights protection',
    contractLaw: 'Contract Law',
    contractLawDesc: 'Contract preparation and negotiation',
    inheritanceLaw: 'Inheritance Law',
    inheritanceLawDesc: 'Inheritance division and guardianship',
    rentalLaw: 'Rental Law',
    rentalLawDesc: 'Tenant and landlord relations',
    taxLaw: 'Tax Law',
    taxLawDesc: 'Tax consultation and disputes',
    itLaw: 'IT Law',
    itLawDesc: 'Technology and internet law',

    needConsultation: 'Need Legal Consultation?',
    teamReady: 'Our professional team is always ready for you.',
    contactUs: 'Contact Us',

    // About
    aboutUs: 'About Us',
    whoWeAre: 'Who We Are?',
    whoWeAreText: 'TAMA & ORAL Law Office was established to provide customer-focused and high-quality legal consulting services. Our team brings an independent and impartial perspective to each case, working to protect our clients\' rights and create solutions.',
    ourMission: 'Our Mission',
    ourMissionText: 'In the field of professional legal consulting, prioritizing customer satisfaction and impeccable legal practice, to provide the highest standards in every case and consulting task.',
    ourVision: 'Our Vision',
    ourVisionText: 'To be a reliable, ethical and professional legal consulting firm in Turkey, preferred by our clients.',
    ourPhilosophy: 'Our Philosophy',
    ourPhilosophyText: '"Creating Solutions, Not Problems" - This principle forms the foundation of all our work. We aim for long-term relationships and satisfactory results for each client.',

    // Team
    ourTeam: 'Our Team',
    professionalMeeting: 'Where professional and experienced lawyers meet',
    founderLawyer: 'Founder Lawyer',
    founderCat: 'Founder Cat',
    omerOral: 'Atty. Ömer Oral',
    omerBio: 'Expert in tax law and commercial law. Has earned client trust with 15+ years of experience.',
    rumeysa: 'Atty. Rumeysa Tama Oral',
    rumeyBio: 'Expert in family law and inheritance law. Her sensitive and holistic approach is appreciated by clients.',
    suzi: 'Lawyer Suzi',
    suziBio: 'The representation of the office spirit and mission. Always ready to listen to consultations with calm energy.',
    ourValues: 'Our Values',
    independence: 'Independence',
    independenceDesc: 'We act completely independently in defending our clients\' interests.',
    ethics: 'Ethics',
    ethicsDesc: 'We maintain high ethical standards in all our work.',
    professionalism: 'Professionalism',
    professionalismDesc: 'We provide the best results with our expert knowledge and experience.',
    reliability: 'Reliability',
    reliabilityDesc: 'Our clients\' trust is the foundation of our work.',
    specializations: 'Specializations',
    moralSupport: 'Moral Support',
    stressManagement: 'Stress Management',
    officeculture: 'Office Culture',

    // Publications
    ourPublications: 'Our Publications',
    currentLegalInfo: 'Current legal information and analysis',
    article1: 'Important Considerations for Vehicle Damage Compensation Claims',
    article1Date: 'March 15, 2024',
    article1Excerpt: 'What do you need to document in a vehicle damage compensation case? What should you do to strengthen your compensation claim?',
    article2: 'Your Rights Against Hidden Terms in Consumer Contracts',
    article2Date: 'March 8, 2024',
    article2Excerpt: 'How can you protect yourself from unfair terms commonly applied to consumers? What are your legal rights?',
    article3: 'A Look at Changes in Rental Agreements',
    article3Date: 'March 1, 2024',
    article3Excerpt: 'How did the new rental law amendments affect tenants and landlords? What important points should you know?',
    article4: 'Evidence Collection in Family Law Cases',
    article4Date: 'February 22, 2024',
    article4Excerpt: 'Types of evidence affecting legal outcomes in family law cases and considerations in their collection.',
    article5: 'Risk Management in Commercial Contracts',
    article5Date: 'February 15, 2024',
    article5Excerpt: 'Provisions that should be included in contracts to protect your business and risk management strategies.',
    article6: 'Preparing a Valid Will',
    article6Date: 'February 8, 2024',
    article6Excerpt: 'What should you do to prevent disputes that may arise after a will is written?',
    readMore: 'Read More',
    subscribe: 'Subscribe to Newsletter',
    newPublications: 'Receive our new publications via email',
    subscribeBtnText: 'Subscribe',
    emailPlaceholder: 'Your email address',

    // Contact
    getInTouch: 'Contact',
    reachOut: 'Reach out to us, we\'ll answer your questions',
    address: 'Address',
    addressText: 'Mansuroğlu Mah. 286/1 Sok. No:16 Ata Plaza K:7 D:28\nBayraklı İzmir, Turkey',
    phone: 'Phone',
    phoneText: '+90 (212) XXX-XXXX',
    mobile: 'Mobile',
    mobilePhone: '0537 937 10 64',
    landline: 'Landline',
    landlinePhone: '0232 486 63 01',
    email: 'Email',
    workingHours: 'Working Hours',
    workingHoursText: 'Monday - Friday: 09:00 - 18:00\nSaturday - Sunday: Closed',
    kvkkText: 'I consent to the processing of my personal data under the Personal Data Protection Law (KVKK) for the purpose of responding to this message.',
    sendMessage: 'Send us a Message',
    fullName: 'Full Name',
    fullNameReq: 'Full Name *',
    emailReq: 'Email *',
    phone2: 'Phone',
    subject: 'Subject *',
    message: 'Your Message *',
    send: 'Send',
    messageReceived: 'Your message has been received. We will contact you as soon as possible.',
    ourLocation: 'Our Location',
    mapPlaceholder: 'Map will be displayed here',
    required: '*',

    // Footer
    legalServices: 'Professional Legal Consulting Services',
    socialMedia: 'Social Media',
    legal: 'Legal',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
    copyright: '© 2024 TAMA & ORAL Law Office. All rights reserved.',
  },

  ar: {
    // Navigation
    home: 'الرئيسية',
    about: 'حول',
    team: 'الفريق',
    publications: 'المنشورات',
    contact: 'اتصل',

    // Home
    firmName: 'تاما وأورال',
    firmSubtitle: 'مكتب قانوني',
    motto: 'خلق الحلول وليس المشاكل',
    lawyerQuote: 'يجب أن يكون المحامي مستشاراً مستقلاً وغير متحيز، يدعم النظام القانوني وحقوق الإنسان.',

    serviceAreas: 'مجالات الخدمة',
    comprehensiveSolutions: 'حلول قانونية شاملة',
    familyLaw: 'قانون الأسرة',
    familyLawDesc: 'الطلاق والحضانة والوراثة والاستشارات الأسرية',
    laborLaw: 'قانون العمل',
    laborLawDesc: 'علاقات العمل والضمان الاجتماعي',
    laborExpert: 'خبير قانون العمل',
    laborExpertDesc: 'احتساب المستحقات وتقارير الخبرة في قضايا العمل',
    commercialLaw: 'القانون التجاري',
    commercialLawDesc: 'المعاملات التجارية وتكوين الشركات',
    realEstateLaw: 'قانون العقارات',
    realEstateLawDesc: 'شراء وبيع الممتلكات وتسويات النزاعات العقارية',
    bankruptcyLaw: 'الإفلاس والتنفيذ',
    bankruptcyLawDesc: 'تحصيل الديون وإجراءات الإفلاس',
    criminalLaw: 'القانون الجنائي',
    criminalLawDesc: 'التدخلات في القضايا الجنائية',
    consumerLaw: 'حقوق المستهلك',
    consumerLawDesc: 'حماية حقوق المستهلك',
    contractLaw: 'قانون العقود',
    contractLawDesc: 'إعداد العقود والتفاوض',
    inheritanceLaw: 'قانون الوراثة',
    inheritanceLawDesc: 'تقسيم الوراثة والولاية',
    rentalLaw: 'قانون الإيجار',
    rentalLawDesc: 'علاقات المستأجرين والملاك',
    taxLaw: 'قانون الضرائب',
    taxLawDesc: 'استشارات الضرائب والنزاعات',
    itLaw: 'قانون تكنولوجيا المعلومات',
    itLawDesc: 'قانون التكنولوجيا والإنترنت',

    needConsultation: 'هل تحتاج استشارة قانونية؟',
    teamReady: 'فريقنا المحترف جاهز دائماً لك.',
    contactUs: 'اتصل بنا',

    // About
    aboutUs: 'حول',
    whoWeAre: 'من نحن؟',
    whoWeAreText: 'تم تأسيس مكتب تاما وأورال القانوني لتقديم خدمات استشارة قانونية عالية الجودة تركز على العميل. يجلب فريقنا منظوراً مستقلاً وغير متحيز لكل قضية، العاملة على حماية حقوق عملائنا وخلق حلول.',
    ourMission: 'مهمتنا',
    ourMissionText: 'في مجال الاستشارة القانونية المهنية، يعطي الأولوية لرضا العميل والممارسة القانونية الخالية من العيوب، لتوفير أعلى المعايير في كل قضية وحالة استشارة.',
    ourVision: 'رؤيتنا',
    ourVisionText: 'أن نكون شركة استشارة قانونية موثوقة وأخلاقية واحترافية في تركيا، يفضلها عملاؤنا.',
    ourPhilosophy: 'فلسفتنا',
    ourPhilosophyText: '"خلق الحلول وليس المشاكل" - تشكل هذه المبادئ الأساس لجميع أعمالنا. نهدف إلى علاقات طويلة الأجل ونتائج مرضية لكل عميل.',

    // Team
    ourTeam: 'فريقنا',
    professionalMeeting: 'حيث يلتقي المحامون المحترفون والمتمرسون',
    founderLawyer: 'محامي مؤسس',
    founderCat: 'قطة مؤسسة',
    omerOral: 'المحامي عمر أورال',
    omerBio: 'خبير في قانون الضرائب والقانون التجاري. كسب ثقة العملاء مع 15+ سنة من الخبرة.',
    rumeysa: 'المحامية رميسة تاما أورال',
    rumeyBio: 'خبيرة في قانون الأسرة وقانون الوراثة. يقدر عملاؤها نهجها الحساس والشامل.',
    suzi: 'المحامية سوزي',
    suziBio: 'تمثيل روح المكتب والمهمة. جاهزة دائماً للاستماع للاستشارات بطاقة هادئة.',
    ourValues: 'قيمنا',
    independence: 'الاستقلالية',
    independenceDesc: 'نتصرف بشكل مستقل تماماً في الدفاع عن مصالح عملائنا.',
    ethics: 'الأخلاقيات',
    ethicsDesc: 'نحافظ على معايير أخلاقية عالية في جميع أعمالنا.',
    professionalism: 'الاحترافية',
    professionalismDesc: 'نقدم أفضل النتائج بمعرفتنا وخبرتنا المتخصصة.',
    reliability: 'الموثوقية',
    reliabilityDesc: 'ثقة عملائنا هي أساس عملنا.',
    specializations: 'التخصصات',
    moralSupport: 'الدعم المعنوي',
    stressManagement: 'إدارة الإجهاد',
    officeculture: 'ثقافة المكتب',

    // Publications
    ourPublications: 'منشوراتنا',
    currentLegalInfo: 'معلومات وتحليلات قانونية حالية',
    article1: 'اعتبارات مهمة لمطالبات تعويض أضرار المركبات',
    article1Date: '15 مارس 2024',
    article1Excerpt: 'ما الذي تحتاج إلى توثيقه في قضية تعويض أضرار المركبات؟ ماذا يجب أن تفعل لتقوية مطالبة التعويض الخاصة بك؟',
    article2: 'حقوقك ضد الشروط المخفية في العقود الاستهلاكية',
    article2Date: '8 مارس 2024',
    article2Excerpt: 'كيف يمكنك حماية نفسك من الشروط غير العادلة المطبقة عادة على المستهلكين؟ ما هي حقوقك القانونية؟',
    article3: 'نظرة على التغييرات في اتفاقيات الإيجار',
    article3Date: '1 مارس 2024',
    article3Excerpt: 'كيف أثرت تعديلات قانون الإيجار الجديد على المستأجرين والملاك؟ ما النقاط المهمة التي يجب أن تعرفها؟',
    article4: 'جمع الأدلة في قضايا قانون الأسرة',
    article4Date: '22 فبراير 2024',
    article4Excerpt: 'أنواع الأدلة التي تؤثر على النتائج القانونية في قضايا قانون الأسرة والاعتبارات في جمعها.',
    article5: 'إدارة المخاطر في العقود التجارية',
    article5Date: '15 فبراير 2024',
    article5Excerpt: 'الأحكام التي يجب تضمينها في العقود لحماية عملك واستراتيجيات إدارة المخاطر.',
    article6: 'إعداد وصية صحيحة',
    article6Date: '8 فبراير 2024',
    article6Excerpt: 'ماذا يجب أن تفعل لمنع النزاعات التي قد تنشأ بعد كتابة الوصية؟',
    readMore: 'اقرأ المزيد',
    subscribe: 'الاشتراك في النشرة الإخبارية',
    newPublications: 'تلقي منشوراتنا الجديدة عبر البريد الإلكتروني',
    subscribeBtnText: 'اشترك',
    emailPlaceholder: 'عنوان بريدك الإلكتروني',

    // Contact
    getInTouch: 'اتصل',
    reachOut: 'اتصل بنا، سنجيب على أسئلتك',
    address: 'العنوان',
    addressText: 'Mansuroğlu Mah. 286/1 Sok. No:16 Ata Plaza K:7 D:28\nBayraklı İzmir, تركيا',
    phone: 'الهاتف',
    phoneText: '+90 (212) XXX-XXXX',
    mobile: 'موبايل',
    mobilePhone: '0537 937 10 64',
    landline: 'هاتف ثابت',
    landlinePhone: '0232 486 63 01',
    email: 'البريد الإلكتروني',
    workingHours: 'ساعات العمل',
    workingHoursText: 'الاثنين - الجمعة: 09:00 - 18:00\nالسبت - الأحد: مغلق',
    kvkkText: 'أوافق على معالجة بياناتي الشخصية وفقاً لقانون حماية البيانات الشخصية التركي (KVKK) لغرض الرد على هذه الرسالة.',
    sendMessage: 'أرسل لنا رسالة',
    fullName: 'الاسم الكامل',
    fullNameReq: 'الاسم الكامل *',
    emailReq: 'البريد الإلكتروني *',
    phone2: 'الهاتف',
    subject: 'الموضوع *',
    message: 'رسالتك *',
    send: 'إرسال',
    messageReceived: 'تم استقبال رسالتك. سنتصل بك في أقرب وقت ممكن.',
    ourLocation: 'موقعنا',
    mapPlaceholder: 'سيتم عرض الخريطة هنا',
    required: '*',

    // Footer
    legalServices: 'خدمات استشارة قانونية احترافية',
    socialMedia: 'وسائل التواصل الاجتماعي',
    legal: 'قانوني',
    privacy: 'سياسة الخصوصية',
    terms: 'شروط الاستخدام',
    copyright: '© 2024 مكتب تاما وأورال القانوني. جميع الحقوق محفوظة.',
  }
};

export default translations;
